// Shared brand + product identity tokens for the landing page.
// One governance kernel, three products — each product gets a signature accent.

export const colors = {
  bg: '#0A0F1F',
  bgDeep: '#060a16',
  bgPanel: '#0d1428',
  blue: '#4A90E2',
  violet: '#9D4EDD',
  teal: '#2DD4BF',
  amber: '#F5B850',
  red: '#F87171',
  text: '#ffffff',
  textSoft: 'rgba(255,255,255,0.62)',
  textFaint: 'rgba(255,255,255,0.4)',
  border: 'rgba(255,255,255,0.08)',
  gradient: 'linear-gradient(135deg, #4A90E2, #9D4EDD)',
} as const

export type ProductId = 'platform' | 'ontext' | 'sentinel'

export interface Product {
  id: ProductId
  name: string
  tagline: string
  description: string
  accent: string
  accentSoft: string
  badge: string
}

export const products: Product[] = [
  {
    id: 'platform',
    name: 'SynKrasis Platform',
    tagline: 'The Agentic Data Engineering Platform',
    description:
      'Connect every source, catalog and profile your metadata, govern PII, run quality checks and durable pipelines — the governance kernel everything else is built on.',
    accent: colors.blue,
    accentSoft: 'rgba(74, 144, 226, 0.12)',
    badge: 'Core Platform',
  },
  {
    id: 'ontext',
    name: 'Ontext',
    tagline: 'Governed Ontology for AI Agents',
    description:
      'Describe your business in plain English. Ontext turns it into a governed ontology any AI agent can query over MCP — accurate answers, PII masked at read time, every question audited.',
    accent: colors.violet,
    accentSoft: 'rgba(157, 78, 221, 0.12)',
    badge: 'Open Source · Apache-2.0',
  },
  {
    id: 'sentinel',
    name: 'Sentinel',
    tagline: 'PII Compliance for AI Pipelines',
    description:
      'Scan datasets, prompts and free text for PII — 25+ entity types including Aadhaar, IBAN and API keys — then mask, score risk and generate audit evidence. Free as a standalone release.',
    accent: colors.teal,
    accentSoft: 'rgba(45, 212, 191, 0.1)',
    badge: 'Free Standalone Release',
  },
]

export const SENTINEL_DEMO_URL = 'http://122.166.212.76:8080/'

export const fontSans = "'DM Sans', sans-serif"
export const fontMono = "'JetBrains Mono', monospace"

export const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
